import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import axios from 'axios';
import { api } from '.';
var baseURL = process.env['NX_JOVE_API']; //Partner CRUD

export function getAllPartners(_x) {
  return _getAllPartners.apply(this, arguments);
}

function _getAllPartners() {
  _getAllPartners = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(queryParams) {
    var res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return api.get(queryParams ? "/partners?".concat(queryParams.toString()) : '/partners');

          case 3:
            res = _context.sent;
            return _context.abrupt("return", res.data);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            console.error('Error getting partners', _context.t0);
            return _context.abrupt("return", null);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 7]]);
  }));
  return _getAllPartners.apply(this, arguments);
}

export function createPartner(_x2) {
  return _createPartner.apply(this, arguments);
}

function _createPartner() {
  _createPartner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(partner) {
    var res;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return api.post('/partners', partner);

          case 3:
            res = _context2.sent;
            return _context2.abrupt("return", res.data);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            console.error('Error creating partner', _context2.t0);
            return _context2.abrupt("return", null);

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  }));
  return _createPartner.apply(this, arguments);
}

export function deletePartner(_x3) {
  return _deletePartner.apply(this, arguments);
}

function _deletePartner() {
  _deletePartner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(partnerId) {
    var res;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return api["delete"]("/partners/".concat(partnerId));

          case 3:
            res = _context3.sent;
            return _context3.abrupt("return", res.data);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            console.error('Error deleting partner', _context3.t0);
            return _context3.abrupt("return", null);

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 7]]);
  }));
  return _deletePartner.apply(this, arguments);
}

export function uploadPartnerLogo(_x4, _x5) {
  return _uploadPartnerLogo.apply(this, arguments);
}

function _uploadPartnerLogo() {
  _uploadPartnerLogo = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(file, partnerId) {
    var formData, res;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            formData = new FormData();
            formData.append('file', file);
            _context4.next = 5;
            return api.post("/partners/".concat(partnerId, "/logo"), formData);

          case 5:
            res = _context4.sent;
            return _context4.abrupt("return", res.data);

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](0);
            console.error('Error uploading partner logo', _context4.t0);
            return _context4.abrupt("return", null);

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 9]]);
  }));
  return _uploadPartnerLogo.apply(this, arguments);
}

export function getPartnerById(_x6) {
  return _getPartnerById.apply(this, arguments);
}

function _getPartnerById() {
  _getPartnerById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(partnerId) {
    var res;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return api.get("/partners/".concat(partnerId));

          case 3:
            res = _context5.sent;

            if (res !== null && res !== void 0 && res.data) {
              _context5.next = 6;
              break;
            }

            throw new Error('No data returned when getting partner');

          case 6:
            return _context5.abrupt("return", res.data);

          case 9:
            _context5.prev = 9;
            _context5.t0 = _context5["catch"](0);
            console.error('Error getting partner', _context5.t0);
            return _context5.abrupt("return", null);

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 9]]);
  }));
  return _getPartnerById.apply(this, arguments);
}

export function getPartnerBySlug(_x7) {
  return _getPartnerBySlug.apply(this, arguments);
}

function _getPartnerBySlug() {
  _getPartnerBySlug = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(partnerSlug) {
    var res;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return api.get("/partners/get_by_slug/".concat(partnerSlug));

          case 3:
            res = _context6.sent;

            if (res !== null && res !== void 0 && res.data) {
              _context6.next = 6;
              break;
            }

            throw new Error('No data returned when getting partner');

          case 6:
            return _context6.abrupt("return", res.data);

          case 9:
            _context6.prev = 9;
            _context6.t0 = _context6["catch"](0);
            console.error('Error getting partner', _context6.t0);
            return _context6.abrupt("return", null);

          case 13:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, null, [[0, 9]]);
  }));
  return _getPartnerBySlug.apply(this, arguments);
}

export function updatePartner(_x8, _x9) {
  return _updatePartner.apply(this, arguments);
}

function _updatePartner() {
  _updatePartner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(partnerId, partner) {
    var res;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return api.patch("/partners/".concat(partnerId), partner);

          case 3:
            res = _context7.sent;
            return _context7.abrupt("return", res.data);

          case 7:
            _context7.prev = 7;
            _context7.t0 = _context7["catch"](0);
            console.error('Error updating partner', _context7.t0);
            return _context7.abrupt("return", null);

          case 11:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, null, [[0, 7]]);
  }));
  return _updatePartner.apply(this, arguments);
}

export function getAllPartnerMembersInvitations(_x10) {
  return _getAllPartnerMembersInvitations.apply(this, arguments);
}

function _getAllPartnerMembersInvitations() {
  _getAllPartnerMembersInvitations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(queryParams) {
    var res;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return api.get("/partner_invitations".concat(queryParams ? "?".concat(queryParams.toString()) : ''));

          case 3:
            res = _context8.sent;
            return _context8.abrupt("return", res.data);

          case 7:
            _context8.prev = 7;
            _context8.t0 = _context8["catch"](0);
            console.error('Error getting partner members', _context8.t0);
            return _context8.abrupt("return", null);

          case 11:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, null, [[0, 7]]);
  }));
  return _getAllPartnerMembersInvitations.apply(this, arguments);
}

export function getPartnerMemberInvitationById(_x11, _x12) {
  return _getPartnerMemberInvitationById.apply(this, arguments);
}

function _getPartnerMemberInvitationById() {
  _getPartnerMemberInvitationById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(invitationId, token) {
    var res;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return api.get("/partner_invitations/".concat(invitationId, "?").concat(token ? "token=".concat(token) : ''));

          case 3:
            res = _context9.sent;
            return _context9.abrupt("return", res.data);

          case 7:
            _context9.prev = 7;
            _context9.t0 = _context9["catch"](0);
            console.error('Error getting partner member invitation', _context9.t0);
            return _context9.abrupt("return", null);

          case 11:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, null, [[0, 7]]);
  }));
  return _getPartnerMemberInvitationById.apply(this, arguments);
}

export function createPartnerMemberInvitation(_x13) {
  return _createPartnerMemberInvitation.apply(this, arguments);
}

function _createPartnerMemberInvitation() {
  _createPartnerMemberInvitation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(invitation) {
    var res;
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return api.post("/partner_invitations", invitation);

          case 3:
            res = _context10.sent;
            return _context10.abrupt("return", res.data);

          case 7:
            _context10.prev = 7;
            _context10.t0 = _context10["catch"](0);
            console.error('Error creating partner member invitation', _context10.t0);
            return _context10.abrupt("return", null);

          case 11:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, null, [[0, 7]]);
  }));
  return _createPartnerMemberInvitation.apply(this, arguments);
}

export function updatePartnerMemberInvitation(_x14, _x15, _x16) {
  return _updatePartnerMemberInvitation.apply(this, arguments);
}

function _updatePartnerMemberInvitation() {
  _updatePartnerMemberInvitation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(invitationId, invitation, token) {
    var res;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            _context11.prev = 0;
            _context11.next = 3;
            return api.patch("/partner_invitations/".concat(invitationId, "?").concat(token ? "token=".concat(token) : ''), invitation);

          case 3:
            res = _context11.sent;
            return _context11.abrupt("return", res.data);

          case 7:
            _context11.prev = 7;
            _context11.t0 = _context11["catch"](0);
            console.error('Error updating partner member invitation', _context11.t0);
            return _context11.abrupt("return", null);

          case 11:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11, null, [[0, 7]]);
  }));
  return _updatePartnerMemberInvitation.apply(this, arguments);
}

export function deletePartnerMemberInvitation(_x17) {
  return _deletePartnerMemberInvitation.apply(this, arguments);
} //Partner Product CRUD

function _deletePartnerMemberInvitation() {
  _deletePartnerMemberInvitation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(invitationId) {
    var res;
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.prev = 0;
            _context12.next = 3;
            return api["delete"]("/partner_invitations/".concat(invitationId));

          case 3:
            res = _context12.sent;
            return _context12.abrupt("return", res.data);

          case 7:
            _context12.prev = 7;
            _context12.t0 = _context12["catch"](0);
            console.error('Error deleting partner member invitation', _context12.t0);
            return _context12.abrupt("return", null);

          case 11:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12, null, [[0, 7]]);
  }));
  return _deletePartnerMemberInvitation.apply(this, arguments);
}

export function getAllPartnerProductsById(_x18, _x19) {
  return _getAllPartnerProductsById.apply(this, arguments);
}

function _getAllPartnerProductsById() {
  _getAllPartnerProductsById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(partnerId, queryParams) {
    var res;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.prev = 0;
            _context13.next = 3;
            return api.get("/partner/promotions/get_all_by_partner_id/".concat(partnerId).concat(queryParams ? "?".concat(queryParams.toString()) : ''));

          case 3:
            res = _context13.sent;
            return _context13.abrupt("return", res.data);

          case 7:
            _context13.prev = 7;
            _context13.t0 = _context13["catch"](0);
            console.error('Error getting partner products', _context13.t0);
            return _context13.abrupt("return", null);

          case 11:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13, null, [[0, 7]]);
  }));
  return _getAllPartnerProductsById.apply(this, arguments);
}

export function getPartnerProductById(_x20) {
  return _getPartnerProductById.apply(this, arguments);
}

function _getPartnerProductById() {
  _getPartnerProductById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(productId) {
    var res;
    return _regeneratorRuntime.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.prev = 0;
            _context14.next = 3;
            return api.get("/partner/promotions/".concat(productId));

          case 3:
            res = _context14.sent;
            return _context14.abrupt("return", res.data);

          case 7:
            _context14.prev = 7;
            _context14.t0 = _context14["catch"](0);
            console.error('Error getting partner product', _context14.t0);
            return _context14.abrupt("return", null);

          case 11:
          case "end":
            return _context14.stop();
        }
      }
    }, _callee14, null, [[0, 7]]);
  }));
  return _getPartnerProductById.apply(this, arguments);
}

export function getPartnerProductBySlug(_x21) {
  return _getPartnerProductBySlug.apply(this, arguments);
}

function _getPartnerProductBySlug() {
  _getPartnerProductBySlug = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(slug) {
    var res;
    return _regeneratorRuntime.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            _context15.prev = 0;
            _context15.next = 3;
            return axios.get("".concat(baseURL, "/partner/promotions/get_valid_by_slug/").concat(slug));

          case 3:
            res = _context15.sent;

            if (res !== null && res !== void 0 && res.data) {
              _context15.next = 6;
              break;
            }

            throw new Error('No data returned when getting partner product by slug');

          case 6:
            return _context15.abrupt("return", res.data);

          case 9:
            _context15.prev = 9;
            _context15.t0 = _context15["catch"](0);
            console.error('Error getting partner product by slug', _context15.t0);
            return _context15.abrupt("return", null);

          case 13:
          case "end":
            return _context15.stop();
        }
      }
    }, _callee15, null, [[0, 9]]);
  }));
  return _getPartnerProductBySlug.apply(this, arguments);
}

export function createPartnerProduct(_x22) {
  return _createPartnerProduct.apply(this, arguments);
}

function _createPartnerProduct() {
  _createPartnerProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(product) {
    var res;
    return _regeneratorRuntime.wrap(function _callee16$(_context16) {
      while (1) {
        switch (_context16.prev = _context16.next) {
          case 0:
            _context16.prev = 0;
            _context16.next = 3;
            return api.post('/partner/promotions', product);

          case 3:
            res = _context16.sent;
            return _context16.abrupt("return", res.data);

          case 7:
            _context16.prev = 7;
            _context16.t0 = _context16["catch"](0);
            console.error('Error creating partner product', _context16.t0);
            return _context16.abrupt("return", null);

          case 11:
          case "end":
            return _context16.stop();
        }
      }
    }, _callee16, null, [[0, 7]]);
  }));
  return _createPartnerProduct.apply(this, arguments);
}

export function uploadPartnerProductBanner(_x23, _x24) {
  return _uploadPartnerProductBanner.apply(this, arguments);
}

function _uploadPartnerProductBanner() {
  _uploadPartnerProductBanner = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(productId, file) {
    var formData, res;
    return _regeneratorRuntime.wrap(function _callee17$(_context17) {
      while (1) {
        switch (_context17.prev = _context17.next) {
          case 0:
            _context17.prev = 0;
            formData = new FormData();
            formData.append('file', file);
            _context17.next = 5;
            return api.post("/partner/promotions/".concat(productId, "/banner"), formData);

          case 5:
            res = _context17.sent;
            return _context17.abrupt("return", res.data);

          case 9:
            _context17.prev = 9;
            _context17.t0 = _context17["catch"](0);
            console.error('Error uploading partner product banner', _context17.t0);
            return _context17.abrupt("return", null);

          case 13:
          case "end":
            return _context17.stop();
        }
      }
    }, _callee17, null, [[0, 9]]);
  }));
  return _uploadPartnerProductBanner.apply(this, arguments);
}

export function updatePartnerProduct(_x25, _x26) {
  return _updatePartnerProduct.apply(this, arguments);
}

function _updatePartnerProduct() {
  _updatePartnerProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(productId, product) {
    var res;
    return _regeneratorRuntime.wrap(function _callee18$(_context18) {
      while (1) {
        switch (_context18.prev = _context18.next) {
          case 0:
            _context18.prev = 0;
            _context18.next = 3;
            return api.patch("/partner/promotions/".concat(productId), product);

          case 3:
            res = _context18.sent;
            return _context18.abrupt("return", res.data);

          case 7:
            _context18.prev = 7;
            _context18.t0 = _context18["catch"](0);
            console.error('Error updating partner product', _context18.t0);
            return _context18.abrupt("return", null);

          case 11:
          case "end":
            return _context18.stop();
        }
      }
    }, _callee18, null, [[0, 7]]);
  }));
  return _updatePartnerProduct.apply(this, arguments);
}

export function deletePartnerProduct(_x27) {
  return _deletePartnerProduct.apply(this, arguments);
}

function _deletePartnerProduct() {
  _deletePartnerProduct = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(productId) {
    var res;
    return _regeneratorRuntime.wrap(function _callee19$(_context19) {
      while (1) {
        switch (_context19.prev = _context19.next) {
          case 0:
            _context19.prev = 0;
            _context19.next = 3;
            return api["delete"]("/partner/promotions/".concat(productId));

          case 3:
            res = _context19.sent;
            return _context19.abrupt("return", res.data);

          case 7:
            _context19.prev = 7;
            _context19.t0 = _context19["catch"](0);
            console.error('Error deleting partner product', _context19.t0);
            return _context19.abrupt("return", null);

          case 11:
          case "end":
            return _context19.stop();
        }
      }
    }, _callee19, null, [[0, 7]]);
  }));
  return _deletePartnerProduct.apply(this, arguments);
}